import { QueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import { ActivityResponse } from '~teacher/hook';
import { queryKey } from '~teacher/hook/activity/queryKey';

import { findStudentIdByUuid } from '../../utils';

export const updateStudentFinished = produce(
  (activityData: ActivityResponse, userUuid: string) => {
    const studentId = findStudentIdByUuid(activityData, userUuid);
    if (studentId) {
      activityData.students[studentId].isFinished = true;
    }
  }
);

export const studentFinishedCacheUpdater = ({
  queryClient,
  activityInstanceId,
  userUuid,
}: {
  queryClient: QueryClient;
  activityInstanceId: number;
  userUuid: string;
}) => {
  queryClient.setQueryData(
    queryKey.byId(activityInstanceId),
    (activityData: ActivityResponse) =>
      updateStudentFinished(activityData, userUuid)
  );
};
